
namespace TabAurous.Purchase {

    @Serenity.Decorators.registerClass()
    export class PurchaseReturnLaborGrid extends Serenity.EntityGrid<PurchaseReturnLaborRow, any> {
        protected getColumnsKey() { return 'Purchase.PurchaseReturnLabor'; }
        protected getIdProperty() { return PurchaseReturnLaborRow.idProperty; }
        protected getInsertPermission() { return PurchaseReturnLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return PurchaseReturnLaborRow.localTextPrefix; }
        protected getService() { return PurchaseReturnLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}